import { loc } from '@/localization';
import { optionsService } from '@/services/instance/optionsService';

import { e } from './style.css';

export function TitleAndDescription({ isPublisher2, isFBOnline }: { isPublisher2: boolean; isFBOnline: boolean }) {
    const loginFromCanva = optionsService.getAppId() === 'canva';

    let title = '';
    let description = '';

    if (isFBOnline) {
        title = loc.Registration.FBOnlineProductTitle;
        description = loc.Registration.FBOnlineProductDescription;

        if (loginFromCanva) {
            title = loc.Registration.CanvaTitle;
        }
    }

    if (isPublisher2) {
        title = loc.Registration.PublisherProductTitle;
        description = loc.Registration.PublisherProductDescription;
    }

    const mobileTitle = isFBOnline && loginFromCanva ? loc.Registration.CanvaTitle : loc.Registration.MobileTitle;

    return (
        <>
            <h1 className={e.title}>{title}</h1>
            <h1 className={e.mobileTitle}>{mobileTitle}</h1>
            <p className={e.subtitle}>{description}</p>
        </>
    );
}
